<template>
  <Component
    v-if="org"
    :to="'/organization/' + org.id"
    :is="tag"
    class="jps-org-span"
    :nolink="nolink || !org"
  >
    <slot :org="org">{{ ls(org?.name) }}</slot>
  </Component>
</template>

<script lang="ts" setup>

interface Props {
  id: string
  tag?: string | Component
  nolink?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  tag: () => 'span',
  nolink: false,
})
const dataStore = useDataStore()
const { ls } = useI18n()
const org = computed(() => dataStore.organization(props.id))
</script>
